<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-skeleton-loader
          :loading="printerLoading"
          :types="skeleton"
          type="article"
          elevation="1"
          height="300"
        >
          <v-card class="elevation-2">
            <v-card-title class="px-9 pt-7">
              Informace
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="6" md="3" sm="4" align-self="center">
                  <div class="printer-label px-9">
                    Název
                  </div>
                </v-col>
                <v-col cols="6" sm="5" align-self="center">
                  <div class="printer-value">
                    {{ printer.name }}
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" md="3" sm="4" align-self="center">
                  <div class="printer-label px-9">
                    Sériové číslo
                  </div>
                </v-col>
                <v-col cols="6" sm="5" align-self="center">
                  <div class="printer-value">
                    {{ printer.serialNumber }}
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" md="3" sm="4" align-self="center">
                  <div class="printer-label px-9">
                    Typ
                  </div>
                </v-col>
                <v-col cols="6" sm="5" align-self="center">
                  <div class="printer-value">
                    <PrinterType :type="printer.type"/>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" md="3" sm="4" align-self="center">
                  <div class="printer-label px-9">
                    Barevná
                  </div>
                </v-col>
                <v-col cols="6" sm="5" align-self="center">
                  <div class="printer-value">
                    {{ printer.color ? "ANO" : "NE" }}
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" md="3" sm="4" align-self="center">
                  <div class="printer-label px-9">
                    Zákazník
                  </div>
                </v-col>
                <v-col cols="6" sm="5" align-self="center">
                  <div class="printer-value">
                    {{ printer.customer }}
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" md="3" sm="4" align-self="center">
                  <div class="printer-label px-9">
                    Stav
                  </div>
                </v-col>
                <v-col cols="6" sm="5" align-self="center">
                  <div class="printer-value">
                    {{ printer.status }}
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" md="3" sm="4" align-self="center">
                  <div class="printer-label px-9">
                    Stav zařízení
                  </div>
                </v-col>
                <v-col cols="6" sm="5" align-self="center">
                  <div class="printer-value">
                    {{ printer.statusDevice }}
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" md="3" sm="4" align-self="center">
                  <div class="printer-label px-9">
                    Chyba
                  </div>
                </v-col>
                <v-col cols="6" sm="5" align-self="center">
                  <div class="printer-value">
                    {{ printer.errorState }}
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" md="3" sm="4" align-self="center">
                  <div class="printer-label px-9">
                    Zpráva, upozornění
                  </div>
                </v-col>
                <v-col cols="6" sm="5" align-self="center">
                  <div class="printer-value">
                    {{ printer.alert }}
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" md="3" sm="4" align-self="center">
                  <div class="printer-label px-9">
                    Vytvořeno
                  </div>
                </v-col>
                <v-col cols="6" sm="5" align-self="center">
                  <div class="printer-value">
                    {{ $dayjs(printer.createdAt).format('D.M.YYYY H:mm') }}
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" md="3" sm="4" align-self="center">
                  <div class="printer-label px-9">
                    Upraveno
                  </div>
                </v-col>
                <v-col cols="6" sm="5" align-self="center">
                  <div class="printer-value">
                    {{ $dayjs(printer.updatedAt).format('D.M.YYYY H:mm') }}
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-skeleton-loader>
      </v-col>
    </v-row>
    <v-row v-if="printer.tonerStatus.values.length">
      <v-col cols="12">
        <v-skeleton-loader
          :loading="printerLoading"
          :types="skeleton"
          type="article"
          elevation="1"
          height="300"
        >
          <v-card class="elevation-2">
            <v-card-title class="px-9 pt-7">
              Stav tonerů
            </v-card-title>
                <v-card-text>
                  <v-simple-table>
                    <thead>
                    <tr>
                      <th class="text-left" style="width: 50%;">Toner</th>
                      <th class="text-left">Hodnota</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr
                      v-for="item in printer.tonerStatus.values"
                      :key="item.type"
                      style="height: 56px"
                    >
                      <td  style="width: 50%;">{{ item.type }}</td>
                      <td>{{ item.value }}</td>
                    </tr>
                    </tbody>
                  </v-simple-table>
                </v-card-text>
          </v-card>
        </v-skeleton-loader>
      </v-col>
    </v-row>
    <v-row v-if="printer.counterStatus.values.length">
      <v-col cols="12">
        <v-skeleton-loader
          :loading="printerLoading"
          :types="skeleton"
          type="article"
          elevation="1"
          height="300"
        >
          <v-card class="elevation-2">
            <v-card-title class="px-9 pt-7">
              Stav počítadel
            </v-card-title>
            <v-card-text>
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                  <tr>
                    <th class="text-left" style="width: 50%;">Kód</th>
                    <th class="text-left">Hodnota</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr
                    v-for="item in printer.counterStatus.values"
                    :key="item.code"
                    style="height: 56px"
                  >
                    <td>{{ item.code }} {{ item.description ? ' - ' +  item.description : '' }}</td>
                    <td>{{ item.value }}</td>
                  </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card-text>
            <v-card-actions class="pt-0 pr-6 pb-6 text-right">
            </v-card-actions>
          </v-card>
        </v-skeleton-loader>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import { downloadFile } from '@/components/mixins/downloadFile';
import PrinterType from '@/components/PrinterType.vue';

export default {
  name: 'CustomerPrinterDetail',
  components: { PrinterType },
  mixins: [downloadFile],
  data() {
    return {
      skeleton: {
        article: 'heading, paragraph@2',
      },
      printerLoading: false,
      printerTonerStatusLoading: false,
      printer: {
        serialNumber: this.$route.params.serialNumber,
        name: null,
        color: null,
        customer: null,
        status: null,
        statusDevice: null,
        errorState: null,
        createdAt: null,
        updatedAt: null,
        tonerStatus: {
          timestamp: null,
          values: [],
        },
        counterStatus: {
          timestamp: null,
          values: [],
        },
        options: {
          page: 1,
          itemsPerPage: 10,
          sortBy: ['code'],
          sortDesc: [false],
        },
      },
      cancel: null,
    };
  },
  methods: {
    ...mapActions({
      getPrinter: 'customer/getPrinter',
    }),
    loadPrinter() {
      this.printerLoading = true;
      this.getPrinter(
        {
          code: this.$route.params.code,
          serialNumber: this.$route.params.serialNumber,
        },
      ).then((response) => {
        this.printer = response.data;
        this.fixTonerSupplyData();
      }).catch((error) => {
        if (error.response.status === 404) {
          this.$router.push({
            name: 'customer404',
          });
        }
      }).finally(() => {
        this.printerLoading = false;
      });
    },
    transformTonerSupplyData() {
      const toners = [];
      this.printer.tonerStatus.values.forEach((e) => {
        toners.push(
          {
            type: e.type,
            amountSent: e.supply ? e.supply.amountSent : 0,
          },
        );
      });
      return toners;
    },
    fixTonerSupplyData() {
      const values = [];
      this.printer.tonerStatus.values.forEach((e) => {
        e.supply.amountSent = e.supply.amountSent.toString();
        values.push(e);
      });
      this.printer.tonerStatus.values = values;
    },
  },
  watch: {
    '$route.params.id': {
      handler() {
        this.loadPrinter();
      },
    },
  },
  created() {
    this.loadPrinter();
  },
};
</script>

<style scoped>
::v-deep input,
::v-deep input {
  padding: 0;
  text-align: right;
}

::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
  text-align: right;
  -webkit-appearance: none;
  margin: 0;
  padding: 0;
}

::v-deep .v-text-field__suffix {
  color: rgba(0, 0, 0, 0.38);
}
</style>
